export const removeOptionIconStyle = (img) => {

    return {
        background: `url(${img}) right center no-repeat`,
        backgroundSize: "28px 28px",
        cursor: "pointer",
        display: "block",
        height: "28px",
        width: "28px",
    };
}

export const iconWrapperStyle = () => {
    return {
        width: "50px"
    }
}